import { render, staticRenderFns } from "./emojiDg.vue?vue&type=template&id=0335644f&scoped=true&"
import script from "./emojiDg.vue?vue&type=script&lang=js&"
export * from "./emojiDg.vue?vue&type=script&lang=js&"
import style0 from "./emojiDg.vue?vue&type=style&index=0&id=0335644f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0335644f",
  null
  
)

export default component.exports